(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // controller for agenda appointment reminders 
    module.controller('AgendaAppointmentsReminderModalController',
        ['reminders', '$uibModalInstance', AgendaAppointmentsReminderModalControllerFn]);

    function AgendaAppointmentsReminderModalControllerFn(reminders, $uibModalInstance) {
        var vm = this;

        // list of reminders
        vm.reminders = [];

        activate();

        // activation work
        function activate() {
            vm.reminders = reminders;
        } // activate

        vm.close = function() {
            $uibModalInstance.close();
        };
    }

})();